import React, {Component} from 'react';
import LGif from "../Assets/Images/loading.gif"
import NoNet from "../Assets/Images/nonet.webp"

class Loading extends Component {
    state = {
        delay: 0
    }
    onExitClick = () => {
        localStorage.clear();
        document.cookie = "auth=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
        window.location.replace("/")
    }
    render() {
        return (
            <section className="loading max-w-lg">
                {
                    this.state.delay !== 1 ?  <div className="loading-content">
                            <img src={LGif} alt="loading" width={40}/>
                            <div className="loading-text">
                                در حال بارگزاری
                            </div>
                        </div>
                        :
                        <div className="reloading mt-5 p-3">
                            <img src={NoNet} alt="عدم ارتباط با سرور" />
                            <p className='text-primary-color fw-bold px-3'>
                                متاسفانه ارتباط با سرور برقرار نشد.

                                <div className='text-secondary-color pt-2'>از اینکه به اینترنت متصل هستید مطمئن شوید و دوباره تلاش کنید.</div>
                            </p>
                            <div>
                                <button className='btn text-white bg-primary-color w-75 mt-3' onClick={() => {window.location.reload()}}>
                                    تلاش مجدد
                                </button>
                                <button className='btn text-white bg-danger w-75 mt-3' onClick={this.onExitClick}>
                                    پاک کردن داده و ورود مجدد
                                </button>
                            </div>
                        </div>
                }
            </section>
        );
    }
    componentDidMount() {
        setTimeout (() => {
            this.setState({delay : 1})
        },20000)
    }
}

export default Loading;

